import React, {useEffect, useState} from 'react';

import './dropdown.multiselectec.clinicians.scss';
import {useLazyQuery} from "@apollo/client";
import gqlSchemaLibrary from "../../services/graphql.schemas";
import {DropDownLog} from "../../services/interactions/elements/dropdown";

function DropdownMultiSelectCliniciansTeams({program, displayLabel, label, items, onChange}){
    const [isOpen, setOpen] = useState(false);
    const [itemsOptions, setItemsOptions] = useState([]);
    const _items = items? items : [];

    useEffect(() => {
        if (program) {
            getProgram({
                variables: {
                    id: program
                }
            })
        }
    }, [program])

    const [getProgram] = useLazyQuery(gqlSchemaLibrary.programs.query.getUsersAndCliniciansByProgram, {
        onCompleted: (data) => {
            const _members = [];
            for (const t of data.getProgramById.teams) {
                const d = {
                    type: 'Team',
                    label: t.name,
                    value: t._id
                };
                _members.push(d);
            }
            for (const m of data.getProgramById.users) {
                const d = {
                    type: 'User',
                    label: m.user.bio.firstname + " " + m.user.bio.lastname,
                    value: m._id,
                };
                _members.push(d);
            }
            setItemsOptions(_members);
        },
        fetchPolicy: 'cache-and-network'
    });

    const isItemsSelected = (option) => {
        if (option.value === null && !_items.length) {
            return true;
        }
        return _items.filter((v) => v.value === option.value).length !== 0;
    }

    const toggleOpen = () => {
        setOpen(!isOpen);
    }

    const _onChange = (option) => {
        return () => {
            if (option.value === null) {
                _items.splice(0, _items.length);
            } else {
                const item = _items.find((i) => i && i.value === option.value);
                const index = _items.indexOf(item);
                if (index !== -1) {
                    _items.splice(index, 1);
                } else {
                    _items.push(option);
                }
            }
            onChange(JSON.parse(JSON.stringify(_items)));
        }
    }

    const getDisplayName  = () => {
        let names = '';
        let index = 0;
        if (_items.length >= 5) {
            return '('+_items.length+') items selected';
        }
        for (let i of _items) {
            names += i.label;
            index++;
            names += index < _items.length? ', ' : '';
        }
        return names;
    }

    const getCliniciansOptions = () => {
        return itemsOptions.filter((i) => i.type === 'User');
    }

    const getTeamsOptions = () => {
        return itemsOptions.filter((i) => i.type === 'Team');
    }

    return (
        <div className={`_dropdownMultiSelectContainerClinicians ${isOpen ? 'open' : ''}`}>
            {
                isOpen ? <div className="_dropdownOverlay" onClick={toggleOpen}></div> : ''
            }
            <div className="actionButton" onClick={toggleOpen}>
                <p className="label">{displayLabel}</p>
                <p className="selectedItems">
                    {
                        getDisplayName()
                    }
                </p>
            </div>
            <div className="_options">
                {
                    label ?
                    <p className="label">{label}</p>
                    : ''
                }
                {
                    getTeamsOptions().map((option, index) => {
                        const selected = isItemsSelected(option);
                        return (
                            <div className={`_option ${selected ? 'selected' : ''}`} onClick={_onChange(option)} key={index}>
                                <div className="check">
                                    <i className="material-icons">
                                        check
                                    </i>
                                </div>
                                <p>
                                    {option.label}
                                </p>
                            </div>
                        )
                    })
                }
                <div className="divider" ></div>
                {
                    getCliniciansOptions().map((option, index) => {
                        const selected = isItemsSelected(option);
                        return (
                            <div className={`_option ${selected ? 'selected' : ''}`} onClick={_onChange(option)} key={index}>
                                <div className="check">
                                    <i className="material-icons">
                                        check
                                    </i>
                                </div>
                                <p>
                                    {option.label}
                                </p>
                            </div>
                        )
                    })
                }
            </div>

        </div>
    )
}

export default DropDownLog(DropdownMultiSelectCliniciansTeams);
